


















import { Instruction } from '@/types/Instruction';
import { Record } from '@/types/Record';
import { mdiImage, mdiText, mdiVideo } from '@mdi/js';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'InstructionsBar',
    props: ['instructions', 'video', 'current'],
    computed: {
        ...mapGetters(['records']),
    },
    methods: {
        getIcon(instruction: Instruction) {
            if (instruction.type === 'text') {
                return mdiText;
            }

            if (instruction.type === 'file' && instruction.file_type === 'image') {
                return mdiImage;
            }

            return mdiVideo;
        },
        isCompleted(instruction: Instruction): boolean {
            return (
                this.records.findIndex((record: Record) => {
                    if (record.instruction_id !== instruction.id) {
                        return false;
                    }

                    if (record.video_id !== this.video.id) {
                        return false;
                    }

                    return true;
                }) !== -1
            );
        },
        getTransformStyle(): string {
            const height = 90;
            let index = this.instructions.indexOf(this.current);
            if (index === -1) {
                index = this.instructions.length;
            }
            const translate = height * index + height / 2 - 10;

            return `translateY(${translate}px)`;
        },
    },
});
